<template>
  <TabBtn
    :tabs="tabs"
    :active-tab="currentTab.value"
    height="100%"
    @tab-click="tabClick"
  >
    <template slot="btn">
      <el-button
        v-if="currentTab.value === 'quotaPricing'"
        type="primary"
        size="mini"
        @click="handleEnterprise"
        >企业定额组价</el-button
      >
    </template>
    <template>
      <QuotaPricing
        ref="quotaPricing"
        v-if="currentTab.value === 'quotaPricing'"
        v-bind="$attrs"
        :importRecordId="importRecordId"
      />
      <CostRcj v-else v-bind="$attrs" />
    </template>
  </TabBtn>
</template>

<script>
import TabBtn from '@/components/TabBtn/index.vue'
import QuotaPricing from './QuotaPricing.vue'
import CostRcj from './CostRcj.vue'

export default {
  name: 'PricingTabs',
  components: {
    TabBtn,
    QuotaPricing,
    CostRcj
  },
  inject: ['detailsVm'],
  props: {
    importRecordId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 页面数据
      tabs: [
        {
          label: '定额组价明细',
          value: 'quotaPricing'
        },
        {
          label: '成本人材机',
          value: 'costRcj'
        }
      ],
      currentTab: {}
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    init() {
      this.tabClick(this.tabs[0])
    },

    tabClick(tab) {
      this.currentTab = tab
    },

    async handleEnterprise() {
      this.detailsVm.loadingContainer = true
      const res = await this.$service.post(
        '/project-unit-budget/enterprise-quota-pricing/' + this.importRecordId,
        {
          id: this.importRecordId
        }
      )
      this.detailsVm.loadingContainer = false
      if (res.code === 200) {
        this.$refs.quotaPricing.getTableTop()
      }
    }
  }
}
</script>

<style scoped lang="less">
.investment-estimate-software {
  padding: 20px;
}
</style>
